export default {
  COMPLETED: 'COMPLETED',
  INCOMPLETED: 'INCOMPLETED',
  FOR_VALIDATE: 'FOR_VALIDATE',
}
